// src/components/Sidebar.js
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode'; // Make sure you have 'jwt-decode' installed

const Sidebar = () => {
    const [expanded, setExpanded] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [decodedToken, setDecodedToken] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                console.log('Decoded token:', decoded); // Debug log
                setDecodedToken(decoded);
                setUserRole(decoded.role || 'USER');
            } catch (error) {
                console.error('Error decoding token:', error);
            }
        }
    }, []);

    // All navigation items uncommented and available
    const navItems = [
        {
            label: 'Dashboard',
            icon: '/icons/dashboard-grey.png',
            route: '/dashboard',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
        {
            label: 'Reports',
            icon: '/icons/reports-grey.png',
            route: '/reports',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
        {
            label: 'Tenant Management',
            icon: '/icons/sb-grey.png',
            route: '/tenant-management',
            roles: ['SUPER_ADMIN']
        },
        {
            label: 'Campaigns',
            icon: '/icons/campaign-grey.png',
            route: '/campaigns',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
        {
            label: 'Leads',
            icon: '/icons/leads-grey.png',
            route: '/leads',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
        {
            label: 'Agent Command Center',
            icon: '/icons/agents-grey.png',
            route: '/agent-command-center',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
        {
            label: 'Agents',
            icon: '/icons/agents-grey.png',
            route: '/agents',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN']
        },
        {
            label: 'Call Studio',
            icon: '/icons/call-studio-grey.png',
            route: '/call-studio',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
        {
            label: 'Smart Dialer',
            icon: '/icons/dialer-grey.png',
            route: '/smart-dialer',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
        {
            label: 'Script Builder',
            icon: '/icons/sb-grey.png',
            route: '/script-builder',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN']
        },
        {
            label: 'SMS Inbox',
            icon: '/icons/sms-inbox-grey.png',
            route: '/sms-inbox',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
        {
            label: 'SLAI Training Portal',
            icon: '/icons/slai-training-grey.png',
            route: '/slai-training',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN']
        },
        {
            label: 'Settings',
            icon: '/icons/settings-grey.png',
            route: '/settings',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN']
        },
        {
            label: 'Agent Notifications',
            icon: '/icons/notification-grey.png',
            route: '/agent-notifications',
            roles: ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']
        },
    ];

    const toggleSidebar = (e) => {
        e.stopPropagation();
        setExpanded(!expanded);
    };

    console.log('Current user role:', userRole); // Debug log

    // Since authentication is disabled, show all navigation items regardless of role
    const filteredNavItems = navItems;

    return (
        <aside className={`sidebar ${expanded ? 'expanded' : ''}`}>
            <div className="sidebar__logo">
                <img src="/SLAILOGO.png" alt="SLAI Logo" className="sidebar__logo-img" />
            </div>
            <nav className="sidebar__nav">
                {filteredNavItems.map((item) => (
                    <NavLink
                        key={item.label}
                        to={item.route}
                        className={({ isActive }) => `sidebar__nav-item ${isActive ? 'active' : ''}`}
                        data-label={item.label}
                    >
                        <img src={item.icon} alt={`${item.label} Icon`} className="sidebar__nav-icon" />
                        <span className="sidebar__nav-text">{item.label}</span>
                    </NavLink>
                ))}
            </nav>
            <div className="sidebar__toggle">
                <button
                    id="sidebar-toggle-btn"
                    className={expanded ? 'expanded' : ''}
                    onClick={toggleSidebar}
                >
                    <img src="/icons/arrow.png" alt="Toggle Sidebar" />
                </button>
            </div>

            {/* Debug info (optional)
            <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                padding: '10px',
                background: '#fff',
                fontSize: '10px'
            }}>
                Role: {userRole || 'None'}<br/>
                Token: {decodedToken ? 'Present' : 'None'}
            </div> */}
        </aside>
    );
};

export default Sidebar;
